export default __webpack_public_path__ + "images/0x5756a28e2aae01f600fc2c01358395f5c1f8ad3a.png";